import React from 'react';
import { SC } from 'src/styles/theme';
import { BasketStyled } from '@components/v2/Basket/BasketStyled';

export const Basket = (props: SC) => <BasketStyled {...props} />;
